import React, { useEffect } from "react";
import { useLang } from "../context/LanguageContext";
import { POLICIES } from "../lib/policies";

export default function InfoPage({ page }) {
  const { lang } = useLang();
  const doc = (POLICIES[page] && (POLICIES[page][lang] || POLICIES[page].en)) || null;

  useEffect(() => { window.scrollTo(0, 0); }, [page]);

  if (!doc) return null;

  return (
    <div className="max-w-3xl mx-auto px-5 md:px-10 py-20 md:py-28" data-testid={`policy-${page}`}>
      <h1 className="serif text-4xl md:text-5xl leading-tight">{doc.title}</h1>
      {doc.updated && <p className="text-[11px] uppercase tracking-[0.25em] text-[#6E685F] mt-4">{doc.updated}</p>}

      {doc.intro && (
        <div className="mt-10 space-y-4">
          {doc.intro.split("\n\n").map((p, i) => (
            <p key={p} className="text-[#C9C0B4] text-[15px] md:text-base leading-[1.9]">{p}</p>
          ))}
        </div>
      )}

      <div className="mt-12 space-y-10">
        {doc.sections.map((s, i) => (
          <section key={s.h} data-testid={`policy-section-${i}`}>
            <h2 className="serif text-xl md:text-2xl text-[#C49A6C] mb-3">{s.h}</h2>
            <div className="space-y-3">
              {s.b.split("\n\n").map((p, j) => (
                <p key={p} className="text-[#8A857D] text-[15px] leading-[1.85]">{p}</p>
              ))}
            </div>
          </section>
        ))}
      </div>

      {doc.footer && (
        <div className="mt-16 pt-8 border-t border-[#262421] space-y-1">
          {doc.footer.split("\n").map((l, i) => (
            <p key={l} className={i === 0 ? "text-[#F2EBE1] text-sm uppercase tracking-widest" : "serif italic text-[#8A857D]"}>{l}</p>
          ))}
        </div>
      )}
    </div>
  );
}
